// extracted by mini-css-extract-plugin
export default {"image":"N0-z","loaded":"O0-z"};